import { trackException } from "services/errorTracker";

/*
This function tries to execute a Pendo function and reports
any errors as console warnings and to Sentry
*/

const tryPendoCommandWithFunction = (__function) => {
  try {
    __function();
  } catch (error) {
    trackException(error);
  }
};

/**
 * This function binds User properties to Pendo user objects
 *
 * @param {User} user
 * @param {Client} client
 */
export function identifyPendoUserWithUserAndClientRecords(user, client) {
  tryPendoCommandWithFunction(() => {
    // pendo is installed globally
    // eslint-disable-next-line no-undef
    pendo.initialize({
      visitor: {
        id: user.id,
        email: user.email,
        name: user.name || "",
        isAda: user.email.includes("@ada.support"),
        created: user.created,
        role: user.role
      },
      account: {
        id: client.handle,
        name: client.name || ""
      }
    });
  });
}
